module.exports = __webpack_public_path__ + "img/features_xapi scorm.463fd699.png";